import React from 'react';
import { svgSprite } from '../../hybrid/wrappers';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import classNames from 'classnames';
import css from './search-window.module.scss';
import { generateCompStylers } from '../../common/utils/styles';
const SearchWindowHead = ({ closeModal, title, customStyle }) => {
    const { stylers, classes } = generateCompStylers(customStyle);

    const widthDimensions = useWindowDimensions();

    return (
        <div
            className={classNames(css?.searchWindowTitleBlock, classes.searchWindowTitleBlock)}
            style={stylers?.searchWindowTitleBlock}
        >
            {widthDimensions < 768 && (
                <div onClick={() => closeModal()} className={css.formCursorPointer}>
                    {svgSprite('arrow-left', {
                        fill: 'var(--greyExtraDarkColor)',
                        width: '16px',
                        height: '16px'
                    })}
                </div>
            )}

            <div>
                <p className={css?.searchWindowTitle}>{title}</p>
            </div>
            {widthDimensions >= 768 ? (
                <div onClick={() => closeModal()} className={classNames('circleButton', css?.searchWindowTitleClose)}>
                    {svgSprite('cross', {
                        className: classNames(css?.searchWindowTitleSvg, css?.formCursorPointer)
                    })}
                </div>
            ) : (
                <div />
            )}
        </div>
    );
};
export default SearchWindowHead;
